// extracted by css-extract-rspack-plugin
export default {"dropdownButton":"wAFdwas9WAAE30LY"};